export default __webpack_public_path__ + "static/media/x_wdt_c_0_1.e8876c6b.mp3";